import { render, staticRenderFns } from "./AdvantagesOfSite.vue?vue&type=template&id=5c47d822&scoped=true&"
import script from "./AdvantagesOfSite.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AdvantagesOfSite.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AdvantagesOfSite.vue?vue&type=style&index=0&id=5c47d822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c47d822",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c47d822')) {
      api.createRecord('5c47d822', component.options)
    } else {
      api.reload('5c47d822', component.options)
    }
    module.hot.accept("./AdvantagesOfSite.vue?vue&type=template&id=5c47d822&scoped=true&", function () {
      api.rerender('5c47d822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/AdvantagesOfSite.vue"
export default component.exports